import { render, staticRenderFns } from "./createshopFood.vue?vue&type=template&id=ffc8baac&scoped=true"
import script from "./createshopFood.vue?vue&type=script&lang=js"
export * from "./createshopFood.vue?vue&type=script&lang=js"
import style0 from "./createshopFood.vue?vue&type=style&index=0&id=ffc8baac&prod&lang=scss&scoped=true"
import style1 from "./createshopFood.vue?vue&type=style&index=1&id=ffc8baac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc8baac",
  null
  
)

export default component.exports